import { FunctionComponent, ReactElement } from "react";

import { Box, IconButton, Typography, styled } from "@mui/material";

import { Trash } from "@phosphor-icons/react";

const Container = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;

    border: 1px solid rgba(191, 191, 191, 1);
    border-radius: ${({ theme }) => theme.spacing(0.5)};
    width: 100%;

    padding: ${({ theme }) => theme.spacing(1)};
    margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

const FileName = styled(Typography)`
    font-size: 14px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const FileDetails = styled(Box)`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};

    max-width: 300px;
    overflow-x: auto;
`;

const DeleteButton = styled(IconButton)`
    color: #ff4d4d;
`;

export interface IAssetContainerProps {
    file: File;
    index: number;
    onDeleteAsset: () => void;
}

export const AssetContainer: FunctionComponent<IAssetContainerProps> = (
    props: IAssetContainerProps,
): ReactElement => {
    const { file, onDeleteAsset } = props;

    return (
        <Container>
            <FileDetails>
                <FileName title={file.name}>{file.name}</FileName>
                <Typography variant="caption" color="text.secondary">
                    {Math.round(file.size / 1024)} KB
                </Typography>
            </FileDetails>
            <DeleteButton onClick={onDeleteAsset} title="Delete">
                <Trash size={20} weight="duotone" />
            </DeleteButton>
        </Container>
    );
};
